import call from '@gov.wa.lni/application.janitorial-workload-calculator/source/interactions/call.ts';
import getContent from '@gov.wa.lni/application.janitorial-workload-calculator/source/interactions/getContent.ts';
import getText from '@gov.wa.lni/application.janitorial-workload-calculator/source/interactions/getText.ts';

export default {
    call,
    getContent,
    getText,
};